import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Humanitarianism.css";
import AudioFloat from "./AudioFloat.js";

export default function Humanitarianism() {
  const bg = "https://lvltravel.s3.us-east-2.amazonaws.com/Africa/066A1546.JPG";
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Small delay so animations start after first paint (feels smoother)
    const t = setTimeout(() => setReady(true), 60);
    return () => clearTimeout(t);
  }, []);

  return (
    <main
      className={`hum-page ${ready ? "is-ready" : ""}`}
      data-light-nav="true"
      aria-labelledby="hum-title"
    >
      {/* Background */}
      <div
        className="hum-bg anim-bg"
        role="img"
        aria-label="A portrait evoking poverty and resilience"
        style={{ backgroundImage: `url(${bg})` }}
      />
      <div className="hum-veil anim-veil" aria-hidden="true" />

      {/* Centered content */}
      <section className="hum-center">
        <header className="hum-header">
          <h1
            id="hum-title"
            className="hum-hed fx-fade-up"
            style={{ "--d": "100ms" }}
          >
            Humanitarianism
          </h1>

          <p
            className="hum-dek fx-fade-up"
            style={{ "--d": "220ms" }}
          >
            Stories of dignity under pressure—work, childhood, and the cost of survival.
          </p>
        </header>

        <nav className="hum-actions">
          <Link
            className="hum-btn fx-pop"
            style={{ "--d": "360ms" }}
            to="/humanitarianism/child-labor"
          >
            <span className="hum-btn__label">Child Labor</span>
            <span className="hum-btn__sub">A story that must be told</span>
          </Link>

          <Link
            className="hum-btn fx-pop"
            style={{ "--d": "480ms" }}
            to="/humanitarianism/causes"
          >
            <span className="hum-btn__label">Causes</span>
            <span className="hum-btn__sub">Where awareness becomes action</span>
          </Link>
        </nav>

        
      </section>
        <AudioFloat
                    srcs={[
                      { src: "https://lvltravel.s3.us-east-2.amazonaws.com/Music/causes.mp3", type: "audio/mpeg" },
                      
                    ]}
                    startMuted={false}
                    startVolume={0.5}
                    loop={true}
                    label="Site background audio"
                    startTime = {20}
                    
                  />
      
    </main>
  );
}